import {
    FaNetworkWired,
    FaServer,
    FaSitemap,
    FaUsers,
} from "react-icons/fa6";

export const CounterSectionCentralOdc = ({ data }) => {
    const counters = [
        {
            label: "ODC",
            value: data?.odc ?? 0,
            icon: FaSitemap,
        },
        {
            label: "ODP",
            value: data?.odp ?? 0,
            icon: FaNetworkWired,
        },
        {
            label: "PPPoE",
            value: data?.pppoe_user ?? 0,
            icon: FaUsers,
        },
    ];

    return (
        <div className="grid grid-cols-2  gap-2">
            {counters.map(({ label, value, icon: Icon }) => {
                const active = Number(value) > 0;

                return (
                    <div
                        key={label}
                        className="
                            flex items-center gap-2.5
                            px-3 py-2.5
                            bg-slate-900
                            border border-slate-700
                            rounded-2xl
                            shadow-sm
                        "
                    >
                        <div
                            className={`
                                shrink-0
                                w-9 h-9
                                flex items-center justify-center
                                rounded-xl
                                text-white
                                ${active ? "bg-blue-500" : "bg-slate-700"}
                            `}
                        >
                            <Icon className="text-sm" />
                        </div>

                        <div className="min-w-0">
                            <p className="text-[9px] font-semibold text-slate-500 uppercase tracking-wide">
                                {label}
                            </p>

                            <p className="text-base font-bold text-white leading-tight">
                                {value}
                            </p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};